var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"imgHolder",staticClass:"img-holder",class:_vm.showImage ? 'img-show' : 'img',on:{"click":_vm.showImageModal}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }